// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#stream-container .pw-5 {
  width: 5%;
}
#stream-container .pw-10 {
  width: 10%;
}
#stream-container .pw-20 {
  width: 20%;
}
#stream-container .pw-25 {
  width: 25%;
}
#stream-container .pw-30 {
  width: 30%;
}
#stream-container .outflow-list {
  height: calc(100vh - 330px);
  overflow: auto;
}

.offcanvas-header {
  padding: 25px 40px 0px 20px !important;
}

.offcanvas-body {
  padding-top: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Stream/Stream.scss"],"names":[],"mappings":"AACE;EACE,SAAA;AAAJ;AAEE;EACE,UAAA;AAAJ;AAEE;EACE,UAAA;AAAJ;AAEE;EACE,UAAA;AAAJ;AAEE;EACE,UAAA;AAAJ;AAEE;EACE,2BAAA;EACA,cAAA;AAAJ;;AAGA;EACE,sCAAA;AAAF;;AAEA;EACE,2BAAA;AACF","sourcesContent":["#stream-container {\r\n  .pw-5 {\r\n    width: 5%;\r\n  }\r\n  .pw-10 {\r\n    width: 10%;\r\n  }\r\n  .pw-20 {\r\n    width: 20%;\r\n  }\r\n  .pw-25 {\r\n    width: 25%;\r\n  }\r\n  .pw-30 {\r\n    width: 30%;\r\n  }\r\n  .outflow-list {\r\n    height: calc(100vh - 330px);\r\n    overflow: auto;\r\n  }\r\n}\r\n.offcanvas-header {\r\n  padding: 25px 40px 0px 20px !important;\r\n}\r\n.offcanvas-body {\r\n  padding-top: 0px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
